import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 50px;

  h2 {
    font-size: 25px;
  }

  .MuiSvgIcon-root {
    font-size: 75px;
  }
`;